import { ReactNode, createContext, useContext } from 'react'
import { Tab } from '../tab'
import { TabsStyling, tabsStyling } from './styling'

const TabsContext = createContext<{ variant: 'pill' | 'plain' }>({ variant: 'pill' })

export function useTabsContext() {
  const context = useContext(TabsContext)
  if (!context) {
    throw new Error('Tab components must be used within a Tabs component')
  }
  return context
}

export type TabsProps = {
  children: ReactNode,
} & TabsStyling

export function Tabs({ children, variant = 'pill' }: TabsProps) {
  return (
    <TabsContext.Provider value={{ variant: variant! }}>
      <div className={tabsStyling({ variant })}>
        {children}
      </div>
    </TabsContext.Provider>
  )
}

Tabs.Tab = Tab
